import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './router.config'
import { getCache, clearCache } from '@/utils'
import { accountPermission } from '@/api'
import { userKey } from '@/config'

Vue.use(Router)

const router = new Router({
  routes,
})

// 获取原型对象push函数
const originalPush = Router.prototype.push

// 获取原型对象replace函数
const originalReplace = Router.prototype.replace

// 修改原型对象中的push函数
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
Vue.prototype.$permission = []
router.beforeEach(async(to, from, next) => {
  const token = getCache('xczn_admin_token')
  const userInfo = getCache(userKey)
  
  if (!token || !userInfo) {
    if (to.name !== 'login') { 
      next({ path: '/#/login' })
    } else {
      next()
    }
  } else {
    // 有token，检查权限
    try {
      const { code, data } = await accountPermission()
      if (code == 0) {
        Vue.prototype.$permission = data.list.map(item => {
          return item.value
        })
        Vue.prototype.$menuLimit = data.menuList.map(item => {
          return item.value
        })
      }
    } catch (err) {
      console.log('权限获取失败', err.message)
    }
    
    // 已登录用户访问login页面，跳转到首页
    if (to.name == 'login') {
      next({ path: "/property/list" })
    } else {
      next()
    }
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js